import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Chip,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CloseIcon from '@mui/icons-material/Close';
import TimeHelper from '../../../../../utils/time';
import { UNDR } from '../userOrderProductDetails.classes';

function UserNotDeliveredReasons({ notDeliveredStatusHistories }: any) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const histories = Array.isArray(notDeliveredStatusHistories) ? notDeliveredStatusHistories : [];

    if (!histories || histories.length === 0) return null;

    return (
        <>
            <Tooltip title={t('orderDetail.notDeliveredReasons')}>
                <Chip
                    className={UNDR.chip}
                    icon={<ReportProblemIcon />}
                    label={t('orderDetail.notDeliveredReasons')}
                    color="error"
                    variant="outlined"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen(true);
                    }}
                    style={{ marginLeft: '1rem', marginTop: '1rem', cursor: 'pointer' }}
                />
            </Tooltip>

            <Dialog
                open={open}
                onClose={(e: any) => {
                    e?.stopPropagation?.();
                    setOpen(false);
                }}
                maxWidth="md"
                fullWidth
                onClick={(e) => e.stopPropagation()}
                slotProps={{ paper: { className: UNDR.dialogPaper } }}
            >
                <DialogTitle
                    className={UNDR.dialogTitle}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#ffebee',
                    }}
                >
                    <div className={UNDR.dialogTitleLeft} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <ReportProblemIcon color="error" />
                        <strong>{t('orderDetail.notDeliveredReasons')}</strong>
                    </div>
                    <IconButton
                        className={UNDR.dialogCloseButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(false);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={UNDR.dialogContent} style={{ padding: '1rem' }}>
                    <Table className={UNDR.table}>
                        <TableHead>
                            <TableRow className={UNDR.headRow}>
                                <TableCell className={UNDR.headCellDate}>
                                    <strong>{t('orderDetail.date')}</strong>
                                </TableCell>
                                <TableCell className={UNDR.headCellDescription}>
                                    <strong>{t('orderDetail.description')}</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {histories.map((item: any, index: number) => (
                                <TableRow className={UNDR.bodyRow} key={item.id || index}>
                                    <TableCell className={UNDR.bodyCellDate}>
                                        {item.createdDate
                                            ? TimeHelper.formatDateHourSecond(item.createdDate)
                                            : '-'}
                                    </TableCell>
                                    <TableCell className={UNDR.bodyCellDescription}>
                                        {item.cargoDescription || '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default UserNotDeliveredReasons;
